module.exports = "/_next/static/media/1dff48e128c2e149d24ebb0d1632d4af.svg";